export default {
  subscriptionCard: {
    applySubReturn: 'Apply for Subscription Card Refund',
    copyCardNo: 'Copy Subscription Card Number',
    copyCardPassword: 'Copy Subscription Card Password',
    returnCard: 'Refund Card',
    extendValidity: 'Extend Validity',
    markValid: 'Mark as Valid',
    void: 'Void',
    cardPassword: 'Subscription Card Password',
    agentId: 'Master Franchisee ID',
    agentName: 'Master Franchisee Name',
    cardType: 'Subscription Card Type',
    cardNo: 'Subscription Card Number',
    cardStatus: 'Status',
    used: 'Used',
    voided: 'Voided',
    returnCardDialog: 'Subscription Card Refund',
    confirm: 'Confirm',
    extendValidityConfirm: 'Are you sure you want to extend the validity of this subscription card by 30 days?',
    voidConfirm: 'Are you sure you want to void this subscription card?',
    markValidConfirm: 'Are you sure you want to mark this subscription card as valid?',
    fissionPayAmount: 'Referral Payment Amount',
    fissionReturnAmount: 'Referral Refund Amount',
    cashPayAmount: 'Cash Payment Amount',
    returnType: 'Refund Method',
    pleaseSelectReturnAccount: 'Please select refund account',
    agentCashAccount: 'Master Franchisee Cash Account',
    cashReturnAmount: 'Cash Refund Amount',
    returnArrivalDate: 'Refund Arrival Date',
    agent: 'Master Franchisee',
    pleaseSelectAgent: 'Please select Master Franchisee',
    cardStatusLabel: 'Subscription Card Status',
    pleaseSelectCardStatus: 'Please select subscription card status',
    pleaseEnterCardNo: 'Please enter subscription card number',
    buyTime: 'Purchase Date',
    buyTimeColumn: 'Purchase Time',
    validTime: 'Validity Date',
    returnApplyStatus: 'Refund Application Status',
    returnApplyStatusColumn: 'Refund Application Status',
    pleaseSelectReturnApplyStatus: 'Please select refund application status',
    cannotApply: 'Not Eligible',
    pendingApply: 'Pending Application',
    applied: 'Applied',
    purchaseNo: 'Purchase Order Number',
    pleaseEnterPurchaseNo: 'Please enter purchase order number',
    exitTextUsed: 'The following subscription cards belong to the same purchase order. Since some cards have already been used, a refund cannot be processed',
    exitTextRelation: 'The following subscription cards belong to the same purchase order. Once refunded, they cannot be used again, and the payment will be returned to the corresponding account. Please confirm whether to proceed',
    exitTextSingle: 'After refund, this subscription card cannot be used again, and the payment will be returned to the corresponding account. Please confirm whether to proceed',
    applySuccess: 'Application submitted successfully!',
    copyFail: 'Copy failed!',
    viewFail: 'Failed to view',
    extendSuccess: 'Extension successful',
    extendFail: 'Extension failed',
    voidSuccess: 'Voided successfully',
    voidFail: 'Void failed',
    markValidSuccess: 'Marked as valid successfully',
    markValidFail: 'Failed to mark as valid',
    cancelSuccess: 'Cancelled successfully',
    cancelFail: 'Cancel failed',
    consumeNo: 'Transaction Number',
    pleaseEnterConsumeNo: 'Please enter transaction number',
    useDate: 'Usage Date',
    to: 'To',
    learningMachineAccount: 'Learning Tablet Account',
    pleaseEnterLearningMachineAccount: 'Please enter Learning Tablet account',
    cardAgent: 'Subscription Card Master Franchisee',
    pleaseSelectCardAgent: 'Please select subscription card Master Franchisee',
    machineAgent: 'Learning Tablet Master Franchisee',
    pleaseSelectMachineAgent: 'Please select Learning Tablet Master Franchisee',
    cardAgentId: 'Subscription Card Master Franchisee ID',
    cardAgentName: 'Subscription Card Master Franchisee Name',
    machineAgentId: 'Learning Tablet Master Franchisee ID',
    machineAgentName: 'Learning Tablet Master Franchisee Name',
    useTime: 'Usage Time',
    useOperator: 'Operator',
    renewRegion: 'Renewal Region',
    renewLevel: 'Renewal Tier',
    renewMonthNum: 'Renewal Duration (Months)',
    songguoSubscriptionCard: 'Pine Cone Subscription Card',
    subscriptionCard: 'Subscription Card',
  },
}
